import { Bleed, Box, IconChevron, Loader, Text } from 'braid-design-system';
import type { ReactNode } from 'react';

import { LegacyProfileIcon } from '../LegacyIcons/LegacyProfileIcon';
import { mobileMenuButtonId } from '../utils/generalUtils';
import type { RenderVariant } from '../utils/typeUtils';

import * as styles from './MenuButton.css';

interface MenuButtonProps {
  variant: RenderVariant;
}

export const MenuButton = ({ variant }: MenuButtonProps) => {
  if (variant === 'logged-in-loading') {
    return (
      <Loader
        data={{ testid: 'mobile-navigation-header-menu-dropdown-loader' }}
        size="xsmall"
        delayVisibility
      />
    );
  }

  let content: { testid: string; children: ReactNode };
  if (variant === 'logged-in-buyer' || variant === 'logged-in-client') {
    content = {
      testid: 'menu-button-logged-in-navigation-header',
      children: (
        <LegacyProfileIcon tone="white" className={styles.profileIcon} />
      ),
    };
  } else {
    content = {
      testid: 'menu-button-logged-out-navigation-header',
      children: <Text weight="medium">Menu</Text>,
    };
  }

  return (
    // Offset transparent button padding
    <Bleed right="small">
      <Box
        component="button"
        id={mobileMenuButtonId}
        className={styles.hamburgerButton}
        aria-label="Menu"
        data={{ testid: content.testid }}
      >
        {content.children}{' '}
        <span className={styles.hamburgerButtonChevron}>
          <IconChevron />
        </span>
      </Box>
    </Bleed>
  );
};
